<template>
    <Button
        has-only-icon
        :variant="variant"
        :size="size"
        :circle="circle"
        aria-label="Close"
    >
        <CloseIcon class="icon" />
    </Button>
</template>

<script lang="ts" setup>
import Button from '../Button.vue';
import CloseIcon from '../../../../images/x.svg?component';
import { ButtonSize } from './Size';
import { Variant } from './Variant';


type Props = {
    variant?: Variant,
    size?: ButtonSize,
    circle?: boolean,
}

withDefaults(defineProps<Props>(), {
    variant: Variant.LIGHT,
    size: ButtonSize.XXS,
    circle: false,
});
</script>
